import { Route, Routes } from 'react-router-dom';

import MeetingPage from './meeting-page';
import MeetingsPage from './meetings-page';

export default function Meetings() {
    return (
        <Routes>
            <Route
                path="/"
                element={<MeetingsPage />}
            />

            <Route
                path="/:meetingId"
                element={<MeetingPage />}
            />
        </Routes>
    );
}